// The nameplate. A broadsheet identifies itself once, at the top, with a
// dateline and a heavy rule — everything below it is the edition.
export function Masthead({ edition }: { edition: Date }) {
  const dateline = edition.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <header className="px-5 pt-[calc(env(safe-area-inset-top)+1.5rem)] pb-4">
      <div className="mx-auto max-w-2xl">
        <p className="kicker text-center">Menswear · Deals · Weekend Fits</p>
        <h1 className="display-xl mt-2 text-center text-[2.75rem] leading-[0.95] font-medium sm:text-6xl">
          Style Scout
        </h1>
        <div className="rule-double mt-4" />
        <p className="mt-2 text-center font-mono text-[0.6875rem] tracking-wide text-ink-faint tabular">
          {dateline}
        </p>
      </div>
    </header>
  );
}
